import { DateRange } from '../types';
import { isDateRange } from './is-date-range';

/**
 * Checks if a date range has at least one date value (either start or end date).
 * This function also acts as a type guard to ensure the input is a valid DateRange.
 *
 * @param range - The value to check
 * @returns `true` if the range is valid and has at least one non-empty date value, `false` otherwise
 *
 * @example
 * ```typescript
 * rangeHasDate(['2023-01-01', '2023-12-31']); // true
 * rangeHasDate(['2023-01-01', '']); // true
 * rangeHasDate(['', '2023-12-31']); // true
 * rangeHasDate(['', '']); // false
 * rangeHasDate([' ', '  ']); // false
 * rangeHasDate(['  2023-01-01  ', '']); // true
 * rangeHasDate(undefined); // false
 * rangeHasDate(null); // false
 * rangeHasDate(['single']); // false (not a valid DateRange)
 * ```
 */
export const rangeHasDate = (range: unknown): range is DateRange => {
  if (!isDateRange(range)) return false;
  const [start, end] = range;
  return !!start?.trim() || !!end?.trim();
};
